var e,n=new Promise((function(n){e=n}));export{e as done,n as ready};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@liff/ready/lib/index.es.js
// module id = 1087
// module chunks = 1